import { ReactNode } from 'react';

import cx from 'classnames';

import { useAppContext } from 'hooks/context/useAppContext';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { defaultGradient, TGradient } from 'utils/gradientUtils';

import s from './Progress.module.css';

type TProps = {
  icon: ReactNode;
  title: string;
  onClick?: () => void;
  isSelected?: boolean;
  isVisited?: boolean;
};

const ColorCircle = ({ gradient }: { gradient: TGradient | string }) => {
  const [startGradient, endGradient] =
    typeof gradient === 'string' ? [gradient, gradient] : gradient.colors;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={s.color}
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          {startGradient && <stop offset="0%" stopColor={startGradient} />}
          {endGradient && <stop offset="100%" stopColor={endGradient} />}
        </linearGradient>
      </defs>
      <circle
        cx="50"
        cy="50"
        r="42"
        stroke="url(#gradient)"
        strokeWidth="4"
        fill="none"
        transform="rotate(-90 50 50)"
      />
    </svg>
  );
};

export const Step = (props: TProps) => {
  const { icon, title, onClick, isSelected, isVisited } = props;
  const { publicUser } = useAppContext();
  const { theme } = useGGTheme();

  const accentGradient = theme?.palette.accentGradient;

  const brandPrimaryColor =
    publicUser?.preferences.brand_color_override_primary ||
    publicUser?.organization_gradient ||
    defaultGradient;

  return (
    <div
      className={cx({
        [s.step]: true,
        [s.stepVisited]: isVisited,
      })}
    >
      <button
        className={cx({
          [s.icon]: true,
          [s.iconSelected]: isSelected,
        })}
        onClick={onClick}
        type="button"
        disabled={!isSelected} // will change in the future when we allow clicking buttons to hop around booking flow
        title={isSelected ? `Selected-${title}` : title}
      >
        {icon}
      </button>
      {isSelected && (
        <ColorCircle gradient={accentGradient || brandPrimaryColor} />
      )}
      <p className={s.buttonText}>{title}</p>
    </div>
  );
};
